// extracted by mini-css-extract-plugin
var _1 = "kx2Jc";
var _2 = "AB5g2";
export { _1 as "base", _2 as "over" }
